import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServerProvider } from '../../providers/server/server';
import {LocalStorageServiceProvider} from '../../providers/local-storage-service/local-storage-service'
import { LoadingController, Loading } from 'ionic-angular';
import { Events } from 'ionic-angular';

export let TRANSACTION_UPDATED_EVENT = "transaction:updated";


@Component({
    selector: 'page-transaction-form',
    templateUrl: 'transaction-form.html',
})
export class TransactionEditPage {
    user_id:String
    account_id:String
    transaction:any
    categories: any
    loader: Loading

    constructor(public navCtrl: NavController, public navParams: NavParams,
                public server: ServerProvider, public localStorage: LocalStorageServiceProvider,
                public loadingCtrl: LoadingController, public events: Events) {

        this.user_id = this.navParams.get("user_id");
        this.account_id = this.navParams.get("account_id")
        this.transaction = this.navParams.get("transaction")
        this.transaction.date = new Date(this.transaction.date).toISOString()

        this.categories = localStorage.getCategories();

        console.log(this.transaction)
    }

    abort() {
        this.navCtrl.pop()
    }

    save(transaction){
        let loader = this.loadingCtrl.create({
            content: "Bitte warten...",
            duration: 5000
        });
        loader.present()


        this.server.updateTransaction(this.user_id, this.account_id,transaction.id, transaction)
        .subscribe(
            data=>{
                console.log(this.events)
                this.events.publish(TRANSACTION_UPDATED_EVENT, data.json());
                loader.dismiss()
                this.navCtrl.pop()
            },
            error=>{
                loader.dismiss()
            }
        )
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad TransactionFormPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/transaction-form/transaction-form-edit.ts